import { CONTRACTOR_CODE_TYPE_ENUM } from "@/static/contractorCodeTypeEnum";
import { Expose } from "class-transformer";
import { IsEnum, IsString } from "class-validator";

export class AddEditContractorCode {
  @Expose()
  @IsString()
  code!: string;

  @Expose()
  @IsEnum(CONTRACTOR_CODE_TYPE_ENUM)
  type!: CONTRACTOR_CODE_TYPE_ENUM;
}
